import { Box, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { useLocation } from 'react-router-dom';
import NoDataIcon from "common/assets/img/usersIconLight.png"

const DataNotFound = ({ title }) => {
    const location = useLocation();

    const messages = {
        "crm/leads": "No Leads Found",
        "crm/contacts": "No Contacts Found",
        "crm/products": "No Products Found",
        "crm/tasks": "No Tasks Found",
        "crm/meeting": "No Meetings Found",
        "crm/phone-call": "No Calls Found",
        "crm/email": "No Emails Found",
        "crm/reporting-analytics": "No Reports Found",
        "password/my-password": "No Passwords Found",
        "password/share-with-me": "No Records Found",
        "password/share-by-me": "No Passwords Shared",
        "recruit/jobProfile": "No Jobs Found",
        "recruit/candidate": "No Candidates Found",
        "recruit/Interview": "No Interviews Found",
        "recruit/department": "No Departments Found",
        "recruit/jobApplication": "No Job Applications Found",
        "recruit/referrals": "No Referrals Found",
        "recruit/offerLetter": "No Offer Letters Found"
    };

    const message = Object.keys(messages).find(path => location.pathname.includes(path));

    return (
        <Box display="flex" justifyContent="center" flexDirection={"column"} gap={"8px"} alignItems="center">
            <Image src={NoDataIcon} height={"32px"} width={"32px"} alt="" />
            <Text className='nodatatitle'> {title ? `No ${title} Found` : message ? messages[message] : "No Data Found"} </Text>
        </Box>
    );
}

export default DataNotFound;
